import Icon from "@able/react/dist/Icon";
import { IconTypes } from "@able/react/dist/Icon/generatedIconTypes";
import { AbleCommonProps } from "../Types";
import './style-nb.scss'
import { classNames } from "../util/helpers";

export type NumberButtonPropType = {
    icon?: IconTypes;
    disabled?: boolean;
    number?: number;
} & React.HTMLAttributes<HTMLButtonElement> & AbleCommonProps;

const NumberButton = (props: NumberButtonPropType) => {

    const { developmentUrl, number, icon, className, ...rest } = props;
    const iconSize = window.innerWidth > 1680 ? '32' : '24';
    const isNumberButton = number !== undefined ? true : false;

    return (
        <button className={classNames('ted-ui-square-button', isNumberButton ? 'ted-ui-number-button' : null, className)} {...rest}>
            {(icon && number === undefined) && <Icon developmentUrl={developmentUrl} icon={icon} size={iconSize} />}
            {number !== undefined && number}
        </button>
    )
}

export default NumberButton;
